import { createSlice } from '@reduxjs/toolkit';

const counterSlice = createSlice({
  name: 'activeCommunity',
  initialState: {
    admin: null,
    resident: null,
  },
  reducers: {
    setAdminCommunityId: (state, action) => {
      state.admin = action.payload
    },
    setResidentCommunityId: (state, action) => {
      state.resident = action.payload
    },
    clearActiveCommunities: (state) => {
      state.admin = null
      state.resident = null
    },
  },
});

export const { setAdminCommunityId, setResidentCommunityId, clearActiveCommunities } = counterSlice.actions;
export default counterSlice.reducer;